@use "~theme/breakpoints";
@use "~theme/typography";

$max-content-width: 440px;

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 24px 0 0;
  max-width: $max-content-width;

  @include breakpoints.desktop {
    margin-top: 56px;
  }
}

.dateHeader {
  @include typography.heading4;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 0;

  @include breakpoints.desktop {
    flex-grow: 0;
    margin-bottom: 80px;
  }
}

.summaryContainer {
  flex-grow: 1;

  // This magic margin-bottom value allows the summary container to scroll
  // at zooms from 140% - 200%, where it would otherwise have its content
  // obscured beneath the fixed footer
  margin-bottom: 80px;

  @include breakpoints.desktop {
    flex-grow: 0;
  }
}

.summaryHeader {
  @include typography.heading2;
  color: var(--blue-01);
  text-align: center;
  margin-bottom: 12px;
}

.footerActions {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  @include breakpoints.desktop {
    position: static;
    background-color: transparent;
  }
}

.summaryButtons {
  display: flex;
  max-width: $max-content-width;
  padding: 16px var(--mobile-gutter);
  width: 100%;
}

.summaryButton {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}
